// externals
import React from 'react';

// components
import { PackagesSectionTitle, StandaloneList, StandaloneItem } from '../PackagesSection.style';

// types
import type { InstalledOptionalEquipmentOption } from '@makemydeal/dr-platform-types';

export const StandaloneOptions: React.FC<{ options: InstalledOptionalEquipmentOption[]; stacked?: boolean }> = ({
    options,
    stacked = false
}) => (
    <div>
        <PackagesSectionTitle level={7} weight="semibold" forwardedAs="h3">
            Standalone Factory Options
        </PackagesSectionTitle>
        <StandaloneList $stacked={stacked}>
            {options.map((option, index) => (
                <StandaloneItem key={index} data-testid={`standalone-option-${index}`} size="small" weight="regular">
                    {option.name}
                </StandaloneItem>
            ))}
        </StandaloneList>
    </div>
);
